import React, { useEffect, useRef } from "react";
import Button from "./Button/Button";

interface MenuButtonImage {
  imagePosition?: "left" | "right";
  imageSrc?: string;
}

interface MenuComponentProps {
  menuTitle: string | JSX.Element;
  menuList: JSX.Element;
  customImage?: MenuButtonImage;
  customButtonCss?: string;
  isOpen: boolean;
  toggleMenu?: () => void;
  closeMenu: () => void;
}

const MenuComponent: React.FC<MenuComponentProps> = ({
  menuTitle,
  menuList,
  customImage,
  customButtonCss,
  isOpen,
  closeMenu,
  toggleMenu,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      closeMenu(); // Close the menu if the click is outside of it
    }
  };

  useEffect(() => {
    // Add event listener to detect outside clicks
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Clean up the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={menuRef}>
      <Button
        onClick={(e) => {
          e.preventDefault();
          toggleMenu?.();
        }}
        className={`flex justify-center hover:underline items-center gap-1 w-full px-1 py-1 rounded-[2px] ${customButtonCss}`}
      >
        {customImage?.imagePosition === "left" && (
          <img
            src={customImage?.imageSrc}
            alt="chevron-down"
            className="h-4 w-4"
          />

        )}

        {menuTitle}

        {customImage?.imagePosition === "right" && (
          <img
            src={customImage?.imageSrc}
            alt="menu-button-icon"
            className="h-4 w-4"
          />
        )}
      </Button>

      {isOpen && (
        <div
          className="bg-white h-auto w-40 mt-[1.25rem] z-[100] absolute origin-top-right right-0 rounded-md border border-gray1 border-b-2 border-b-gray-300"
          onClick={closeMenu}
        >
          {menuList}
        </div>
      )}
    </div>
  );
};

export default MenuComponent;
